import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-66bf996e"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "BOX" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "map-box" }, [
  /*#__PURE__*/_createElementVNode("div", {
    id: "map",
    class: "map"
  })
], -1))
const _hoisted_3 = [
  _hoisted_2
]

import { onMounted, ref } from "vue";
import AMapLoader from "@amap/amap-jsapi-loader";
import { userInfo } from "./config";


export default /*#__PURE__*/_defineComponent({
  __name: 'index',
  setup(__props) {

const map = ref<any>(null);
onMounted(async () => {
  AMapLoader.load({
    key: "98da2fba2ef1027023a833f2fbec7af7",
    version: "2.0", // 指定要加载的 JSAPI 的版本
    plugins: ["AMap.ToolBar"], // 插件列表
  }).then((AMap) => {
    map.value = new AMap.Map("map", {
      center: [121.453476, 31.199004], // 中心点经纬度
      zoom: 12, // 缩放级别
      zooms: [3, 18], //设置缩放级别范围 3-20 级
      viewMode: "2D", //设置地图模式
    });

    //添加工具条控件，工具条控件集成了缩放、平移、定位等功能按钮在内的组合控件
    map.value.addControl(new AMap.ToolBar());

    // 创建 InfoWindow 实例，用于显示信息窗口
    const infoWindow = new AMap.InfoWindow({
      isCustom: true, // 使用自定义内容
      offset: new AMap.Pixel(16, -35), // 设置窗口偏移量
    });

    //创建点标记
    // new AMap.Marker({
    //   map: map.value,
    //   position: [121.453476, 31.199004],
    // });
    const markers = userInfo.map((point) => {
      return {
        lnglat: point.position,
        map: map.value,
        data: point,
      };
    });

    var _renderClusterMarker = function (context: any) {
      const content = `<div style="user-select: none;">
        <img style="width: 65px;" src="https://www.transplantation.com.cn/wp-content/uploads/2025/01/avatar.png" alt="">
        <span style="position: absolute;top: 12px;right: 6px;width: 20px;height: 20px;line-height: 20px;text-align: center;color: #fff;"> ${context.count}</span>
           </div>`;
      var offset = new AMap.Pixel(-9, -9);
      context.marker.setContent(content);
      context.marker.setOffset(offset);
    };
    var _renderMarker = function (context: any) {
      const content = `<div style="user-select: none;">
        <img style="width: 65px;" src="https://www.transplantation.com.cn/wp-content/uploads/2025/01/avatar1.png" alt=""></div>`;
      var offset = new AMap.Pixel(-9, -9);
      context.marker.setContent(content);
      context.marker.setOffset(offset);
    };

    // 初始化 MarkerCluster
    map.value!.plugin("AMap.MarkerCluster", () => {
      const markerCluster = new AMap.MarkerCluster(map.value, markers, {
        gridSize: 60, // 设置网格像素大小
        renderClusterMarker: _renderClusterMarker, // 自定义聚合点样式
        renderMarker: _renderMarker, // 自定义非聚合点样式
      });

      // const markerCluster = new AMap.MarkerCluster(map.value, markers, {
      //   styles: styles,
      // });

      // 监听聚合标记的点击事件
      markerCluster.on("click", (e: any) => {
        const markers = e.clusterData;
        const markersLength = markers.length;
        const zoomLevel = map.value.getZoom();
        if (zoomLevel > 11) {
          let con = "<div style='max-height: 400px;overflow-y: auto;'>";
          markers.forEach((element: any, index: number) => {
            con += `<div style="padding: 10px;background: #fff;text-align: center;">
            <img style="width: 100px;border-radius: 50%;" src="https://www.transplantation.com.cn/wp-content/uploads/2025/01/${
              element.data.photo ? element.data.name : "默认头像"
            }.png" alt="">
            <p style="color: #226DC2;font-size: 16px;font-weight: 700;">${
              element.data.name
            }</p>
            <p style="margin: 4px;color: #226DC2;font-size: 14px;font-weight: 500;">${
              element.data.post
            }</p>
            <p style="width: fit-content;margin: 12px auto !important;padding: 12px; display: flex;color: #19212F; align-items: center;justify-content: center;gap: 13px;font-size: 16px;background: #F9F9F9;">
              <img src="https://www.transplantation.com.cn/wp-content/uploads/2025/01/tutou.png" alt="">
              <span style="lineHeight: 24px;">导师：${
                element.data.supervisor
              }</span>
            </p>
            <div style="width: 302px;height: 1px; margin: 12px 0;background: #EEEEEE;"></div>
            <p style="padding: 3px 4px;color: #19212F;font-size: 14px;font-weight: 500;"><span style="color: #3E454E;margin: 4px;">现工作单位:</span>${
              element.data.employer
            }</p>
            <p style="padding: 3px 4px;color: #19212F;font-size: 14px;font-weight: 500;"><span style="color: #3E454E;margin: 4px;">研究生课题:</span>${
              element.data.project
            }</p>
            <p style="padding: 3px 4px;color: #19212F;font-size: 14px;font-weight: 500;">
              <span style="color: #3E454E;margin: 6px">所在科室:</span>${
                element.data.office || "--"
              }
              <span style="color: #3E454E;margin: 6px 6px 6px 40px;">现住址:</span>${
                element.data.address || "--"
              }
            </p>
            <p style="padding: 8px 4px;color: #888888;font-size: 14px;">入学时间:${
              element.data.enrollment_time || "--"
            } | 毕业时间:${element.data.graduation_time || "--"}</p>
          </div>`;
          if (markersLength > 1 && markersLength !== index + 1) {
            con += `<div style="width: 100%;height: 10px;background: #eeeeee;"></div>`
          }
          });
          con += "</div>";
          // 打开信息窗口
          infoWindow.setContent(con);
          infoWindow.open(map.value, markers[0].lnglat);
        } else {
          if (markers.length === 1) {
            map.value.setCenter(markers[0].lnglat);
            map.value.setZoom(18);
          } else {
            map.value.setCenter(markers[0].lnglat);
            map.value.setZoom(zoomLevel + 3 > 18 ? 18 : zoomLevel + 3);
          }
        }
      });
    });
  });
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, _hoisted_3))
}
}

})